<script>
import VueTagsInput from '@johmun/vue-tags-input'
import AddAdmins from '@adminCompanies/mixins/add-admins.vue'

export default {
  components: {
    VueTagsInput,
  },
  mixins: [AddAdmins],
  props: {
    itemOpen: { type: Number, required: false, default: 0 },
    itemType: { type: String, required: false, default: null },
    companyId: { type: [String, Number], required: false, default: null },
    isEditForm: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      hubAccess: this.itemOpen,
      hubType: this.itemType || (this.itemOpen === 0 ? 'company' : 'school'),

      userTag: '',
      userTags: [],
      userDisplayTags: [],
    }
  },
  watch: {
    userTag: 'searchUsers',
    hubType: 'setHubAccess',
  },
  methods: {
    getFormData() {
      return {
        open: this.hubAccess,
        type: this.hubType,
      }
    },
    updateUserTags(newTags) {
      this.userDisplayTags = []
      this.userTags = newTags
    },
    setHubAccess() {
      if (this.hubType === 'company') {
        this.hubAccess = 0
      }
      if (this.hubType === 'school') {
        this.hubAccess = 1
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="mb-12">
      <h3 class="text-2xl text-blue-darker mb-5">Business or School Type</h3>
      <div class="flex items-center mb-2">
        <label for="company" class="mr-5 flex items-center cursor-pointer">
          <span :class="$style.radioBox">
            <input
              id="company"
              v-model="hubType"
              type="radio"
              name="hubType"
              value="company"
              :class="$style.radio"
            />
          </span>
          <span class="ml-2">Business</span>
        </label>
        <label for="school" class="ml-2 flex items-center cursor-pointer">
          <span :class="$style.radioBox">
            <input
              id="school"
              v-model="hubType"
              type="radio"
              name="hubType"
              value="school"
              :class="$style.radio"
            />
          </span>
          <span class="ml-2">School</span>
        </label>
      </div>
    </div>

    <div v-if="isEditForm">
      <h3 class="text-2xl text-blue-darker mb-5">Business or School Admins</h3>
      <div class="w-full mb-4">
        <label for="searchStr" class="block mb-3">Add Admins:</label>
        <VueTagsInput
          v-model="userTag"
          :tags="userTags"
          :autocomplete-items="userDisplayTags"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search for individual users"
          @tags-changed="updateUserTags"
        />
      </div>
      <button
        class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
        @click="addSearchAdmins"
      >
        Add selected users as admins to Hub
      </button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.radioBox {
  @apply flex border border-gray rounded-full h-4 w-4 mr-1;
}
.radio {
  @apply appearance-none cursor-pointer inline-block select-none bg-white outline-none rounded-full align-middle;

  width: 14px;
  height: 14px;
}
.radio:checked {
  @apply bg-blue border-2 border-solid border-white;
}
</style>
